import type { Locale } from '@tuic/i18n';
import { CacheTag, Oss } from '../../index';
import { remember, serializeDataToCacheKey } from '@tuic/cache';

export async function getEventsBaseData(locale: Locale) {
  const { data, error } = await Oss.getEventsBaseData({
    query: {
      locale,
    },
  });

  if (error) {
    console.error(`Could not fetch events base data for locale: ${locale}`);
    console.error(error);

    return undefined;
  }

  return data;
}

export const cachedGetEventsBaseData = (locale: Locale) => {
  return remember(
    serializeDataToCacheKey([CacheTag.oss, 'getEventsBaseData', locale]),
    () => getEventsBaseData(locale),
    {
      tags: [CacheTag.oss, 'getEventsBaseData'],
      ttl: 600,
    },
  );
};
